// Before you start:
// 1. Add NPM_TOKEN from npn to the repo -> Settings / Secrets and variables / Actions
// 2. Change name and URL in package ge.json file
// 3. Remove these comments
window.Webflow ||= [];
window.Webflow.push(() => {
  // Write your code here
});
